import React, { ReactNode } from 'react'

import styles from './EnterpriseReportBox.module.scss'

interface EnterpriseReportBoxProps {
  header?: ReactNode
  content?: ReactNode
  footer?: ReactNode
  className?: string
}

export default function EnterpriseReportBox({
  header,
  content,
  footer,
  className = '',
}: EnterpriseReportBoxProps) {
  return (
    <div className={`${styles.container} ${className}`}>
      {header && <div className={styles.header}>{header}</div>}

      {content && <div className={styles.content}>{content}</div>}

      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  )
}
